import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface CreateGroupBoPayload {
  name: string;
  member_ids: number[];
  description: string;
}

export const useCreateCustomerIamGroup = (customerId: number) => {
  const queryClient = useQueryClient();

  const createGroup = async (data: CreateGroupBoPayload) => {
    const response = await Axios.post(
      `${POST_URL(customerId.toString()).createGroup}`,
      data
    );
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, CreateGroupBoPayload>(
    createGroup,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customerGroup', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
